'use client';

import FruitTreePlannerContent from './FruitTreePlannerContent';
import type { FruitPollinationFruitType } from '@/data/fruitPollination';

export default function FruitTreePlannerClientShell({
  initialFruitType,
  initialVarietyQuery,
}: {
  initialFruitType: FruitPollinationFruitType | null;
  initialVarietyQuery: string | null;
}) {
  return (
    <FruitTreePlannerContent
      initialFruitType={initialFruitType}
      initialVarietyQuery={initialVarietyQuery}
    />
  );
}
